// ══════════════════════════════════════════════════════════════
// src/firebase-core.js
// SAKSHAM Digital Field Operations System
//
// Auth-only Firebase init — used by Login page so the initial
// bundle does not include the Firestore / Storage SDKs.
// All other modules continue to import from ./firebase (full init).
// ══════════════════════════════════════════════════════════════

import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

// Reuse the existing app instance if firebase.js already ran (avoids duplicate-app error)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export default app;
